import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { PermissionCheckAddCommentQuery } from './PermissionCheckAddCommentQuery.graphql.ts';
import type {
	PermissionCheckAddCommentQuery$data,
	PermissionCheckAddCommentQuery$variables,
} from './__generated__/PermissionCheckAddCommentQuery.graphql.ts';

export function preloadAddCommentPermissionCheck(contentId: string) {
	return query<PermissionCheckAddCommentQuery$data, PermissionCheckAddCommentQuery$variables>({
		query: PermissionCheckAddCommentQuery,
		variables: {
			contentId,
		},
	});
}
